<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" style="max-height: 90px;" alt="logo"></a>
                    <p style="margin-top:-10px">
                        Siamo specializzati nella formazione privata e finanziata per il completamento dell'offerta professionale di PMI e pubbliche amministrazioni.
                    </p>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/share/1JexMfDSV2/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/formalab1?igsh=a2tqMWd0d2ZxbGV2" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="https://www.linkedin.com/company/formalab-s-r-l-/" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>
                        <div class="row pt-3">
                            <div class="col-12 p-0" align="left">
                                <a href="https://apps.apple.com/it/app/discentya/id6468484981" target="_blank">
                                    <img src="assets/img/applestore-badge-white.png" style="width: 160px;">
                                    <img src="assets/img/googlestore-badge-white.png" class="ms-3" style="width: 160px;">
                                </a>
                            </div>
                        </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>LINK</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>DOVE SIAMO</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Sede Legale<br>Via G. Mengoni, 4 - 20121 Milano</li>
                        <li><i class='bx bx-map'></i>Sede Operativa<br>Via F. Cilea, 91 - 90144 Palermo</li>
                        <li><i class='bx bx-map'></i>Sede Operativa<br>Via F. Leopardi, 7 – 90144 Palermo</li>
                        <li><i class='bx bx-map'></i>Sede Operativa<br>P.zza Cavour, 14 – 95125 Catania</li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contatti</h3>
                    <ul class="footer-links-list">
                        <li><i class='bx bx-phone-call'></i><a href="tel:+39091306285" class="ms-2">Telefono: (+39) 091-306285</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:info@formalabsrl.it" class="ms-2">email: info@formalabsrl.it</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:servizi@formalabsrl.it" class="ms-2">email: servizi@formalabsrl.it</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:formalabsrl@pec.it" class="ms-2">PEC: formalabsrl@pec.it</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+39091306285" class="ms-2">Lunedì-Venerdì: 09:00 ÷ 18:00</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2025 Discentya LMS - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2 d-none">
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
